import React from "react";
import { formatSidebarTime } from "../../utils/dateUtils";

const ChatListItem = ({
  name,
  online,
  onClick,
  lastMessageTime,
  unreadMessageCount,
}) => {
  const capitalizeFirstChar = (name) => {
    if (!name) return "";
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  return (
    <div
      className={`chat-list-item flex items-center px-3 py-3 hover:bg-gray-200 cursor-pointer border-b ${
        unreadMessageCount > 0 ? "unread" : ""
      }`}
      onClick={onClick}
    >
      <div className="relative w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center text-white font-bold text-lg">
        {name?.charAt(0)?.toUpperCase()}
        {online && (
          <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></span>
        )}
      </div>
      <div className="ml-3 flex-1 flex items-center pt-2">
        <div className="flex flex-col">
          <span
            className={`name ${
              unreadMessageCount > 0 ? "font-bold" : "font-normal"
            }`}
          >
            {capitalizeFirstChar(name)}
          </span>
          {lastMessageTime && (
            <p className="text-gray-600  ">{formatSidebarTime(lastMessageTime)}</p>
          )}
        </div>
      </div>
      {unreadMessageCount > 0 && (
        <span className="ml-2 bg-green-500 text-white text-xs rounded-full px-2 py-1">
          {unreadMessageCount}
        </span>
      )}
    </div>
  );
};

export default ChatListItem;
